import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { clearUserCredentials } from '../../actions/application';
import { KEY_USER_ID, CURRENT_USER } from '../../services/state';

const LOGIN_PATH = '/login';
// KEY_USER_ID is only ever written/removed when window === window.top
// (see saveState/removeState in services/state.js), so it never fires this
// event for a tab running embedded in an iframe. CURRENT_USER is removed
// unconditionally on logout regardless of embed state, so it's included here
// too to catch that case.
const LOGOUT_KEYS = [KEY_USER_ID, CURRENT_USER];

/**
 * The native `storage` event only fires in OTHER tabs than the one that
 * changed localStorage, so it's a free cross-tab logout signal: when one tab
 * clears KEY_USER_ID/CURRENT_USER (removeState()) or wipes localStorage
 * entirely (localStorage.clear() -> key === null), every other tab hears
 * about it here and logs itself out too, instead of resurrecting the session
 * on its next debounced saveState() write.
 */
const CrossTabLogoutWatcher = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleStorage = (event) => {
      if (event.storageArea !== localStorage) return;
      const isLogoutSignal = event.key === null || (LOGOUT_KEYS.includes(event.key) && event.newValue === null);
      if (!isLogoutSignal) return;
      if (window.location.pathname.startsWith(LOGIN_PATH)) return;

      dispatch(clearUserCredentials());
      window.location.replace(LOGIN_PATH);
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, [dispatch]);

  return null;
};

export default CrossTabLogoutWatcher;
